import firebase from 'firebase';


var config = {
	apiKey: "AIzaSyBdCjXuky1ONLSSk-Zwfv0fG3opQnSRmGU",
	authDomain: "acacya-2017v1.firebaseapp.com",
	databaseURL: "https://acacya-2017v1.firebaseio.com/",
	//databaseURL: "https://testacacya.firebaseio.com/",
	projectId: "acacya-2017v1",
	storageBucket: "acacya-2017v1.appspot.com",
	messagingSenderId: "460102106496"

};

const secondaryApp = firebase.initializeApp(config, "Secondary");


export default secondaryApp;


// WEBPACK FOOTER //
// ./src/Components/BD/secondaryApp.js